import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { Box, Hint, Label } from '..';
import { Components as ReactSelectComponents } from './select.style';
import CreatableReactSelect from './CreatableReactSelect';
import ErrorMessage from '../ErrorMessage';
import DefaultSelect from './DefaultSelect';
import AsyncReactSelect from './AsyncReactSelect';
const ReactSelect = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
      className = 'reactSelect',
      isCreatableOptions = false,
      isAsync = false,
      error,
      fit = 'medium',
      hint,
      id,
      label,
      orientation = 'vertical',
      width,
      isSearchable = false,
      onInputChange,
      suggestType = 'static',
      menuIsOpen
    } = _a,
    rest = __rest(_a, ["className", "isCreatableOptions", "isAsync", "error", "fit", "hint", "id", "label", "orientation", "width", "isSearchable", "onInputChange", "suggestType", "menuIsOpen"]);
  const [menuOpen, setMenuOpen] = useState(false);
  const onInputValueChange = (val, action) => {
    if (suggestType === 'dynamic') {
      if (val !== '') {
        setMenuOpen(true);
      } else {
        setMenuOpen(false);
      }
    }
    if (typeof onInputChange === 'function') {
      onInputChange(val, action);
    }
  };
  return _jsx(ReactSelectComponents.RefWrapper, _extends({
    className: "refWrapper ".concat(className),
    ref: ref
  }, {
    children: _jsxs(ReactSelectComponents.Wrapper, _extends({
      className: "wrapper-".concat(className, " ").concat(className),
      width: width,
      display: "flex",
      alignItems: orientation === 'vertical' ? 'unset' : 'center',
      flexDirection: orientation === 'vertical' ? 'column' : 'row',
      onMouseDown: e => {
        e.nativeEvent.stopPropagation();
      }
    }, {
      children: [label && (typeof label === 'string' ? _jsx(Label, _extends({
        id: id,
        className: className,
        label: label,
        fit: fit,
        orientation: orientation
      }, rest)) : label), isAsync ? _jsx(AsyncReactSelect, _extends({
        fit: fit,
        id: id,
        error: error,
        isCreatableOptions: isCreatableOptions,
        onInputValueChange: onInputValueChange,
        isSearchable: true
      }, rest)) : isCreatableOptions ? _jsx(CreatableReactSelect, _extends({
        fit: fit,
        id: id,
        error: error,
        onInputValueChange: onInputValueChange,
        isSearchable: true
      }, rest)) : _jsx(Box, _extends({
        flex: "1",
        position: "relative"
      }, {
        children: _jsx(DefaultSelect, _extends({
          fit: fit,
          id: id,
          error: error,
          menuOpen: menuOpen,
          onInputValueChange: onInputValueChange,
          isSearchable: suggestType === 'dynamic' ? true : isSearchable,
          suggestType: suggestType,
          menuIsOpen: menuIsOpen
        }, rest))
      })), error && _jsx(ErrorMessage, _extends({
        fit: fit
      }, rest)), hint && _jsx(Hint, _extends({
        hint: hint,
        fit: fit
      }, rest))]
    }))
  }));
});
export default ReactSelect;